export default "__VITE_ASSET__b84a51ba__"